"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const Icon = require('react-native-vector-icons/dist/MaterialCommunityIcons').default;
exports.Icon = Icon;
